import React, { Component } from 'react';

import ProjectHeadbangingBird from '../_Projects/headbangingbird';
import ProjectDropRacing from '../_Projects/dropracing';
import ProjectRespira from '../_Projects/respira';
import ProjectSardinhas from '../_Projects/sardinhas';
import ProjectFawna from '../_Projects/fawna';
import ProjectIllustrations from '../_Projects/illustrations';
import ProjectFish from '../_Projects/fish';
import ProjectBranding from '../_Projects/branding';
import ProjectFreebies from '../_Projects/freebies';
import ProjectDailyRiver from '../_Projects/dailyriver';

class Project extends Component {
	UNSAFE_componentWillReceiveProps() {
		localStorage.setItem('lastPath', this.props.location.pathname);
	}

	render() {
		return (
			<main className="project-page" id="project-page">
				<section className="container">
					{this.props.match.params.id === 'dropracing' && <ProjectDropRacing />}
					{this.props.match.params.id === 'freebies' && <ProjectFreebies />}
					{this.props.match.params.id === 'headbangingbird' && <ProjectHeadbangingBird />}
					{this.props.match.params.id === 'respira' && <ProjectRespira />}
					{this.props.match.params.id === 'illustrations' && <ProjectIllustrations />}
					{this.props.match.params.id === 'sardinhas' && <ProjectSardinhas />}
					{this.props.match.params.id === 'fawna' && <ProjectFawna />}
					{this.props.match.params.id === 'fish' && <ProjectFish />}
					{this.props.match.params.id === 'branding' && <ProjectBranding />}
				</section>
			</main>
		);
	}
}

export default Project;
